import Utils from 'src/utils';
import { ABSENCES_FLAG } from 'src/constants/workTimeService';
import dayjs from 'dayjs';
import { WTS_MOMENT_DATE_MASK } from 'src/constants/dayjs';
import { isNil, uniq } from 'ramda';
class PostMultipleEventsToPlannerV2Adapter {
    static adapt(rawRequest, params = { skipOverlapping: true, excludeWeekends: false }) {
        const request = rawRequest.map(Utils.objects.capitalizeObjectKeysRecursively);
        const jobs = [];
        const absences = [];
        request.forEach((item) => {
            item.UserIds.forEach((userId) => {
                // @ts-ignore IsLeave is added in Planner component
                if (item.IsLeave || item.LeaveId) {
                    absences.push(PostMultipleEventsToPlannerV2Adapter.adaptAbsenceItem(item, userId));
                }
                else {
                    jobs.push(PostMultipleEventsToPlannerV2Adapter.adaptJobItem(item, userId));
                }
            });
        });
        return {
            jobs: {
                SkipOverlapping: params.skipOverlapping,
                ExcludeWeekends: params.excludeWeekends,
                JobItems: uniq(jobs)
            },
            absences: {
                ExcludeWeekends: params.excludeWeekends,
                AbsenceItems: uniq(absences)
            }
        };
    }
    static adaptJobItem(job, userId) {
        const { start, end } = PostMultipleEventsToPlannerV2Adapter.getCreatedEventPeriod(job);
        return {
            Comments: job.Comments,
            DepartmentId: Number(job.DepartmentId),
            End: end,
            // #37689: only sent when the planner asked for additional work; the API plans a shift without
            // the field as ordinary work, and warns for employees who have no flexible contract.
            IsAdditionalWork: job.IsAdditionalWork || undefined,
            IsRestricted: job.IsRestricted,
            JobId: Number(job.JobId),
            ShiftId: Number(job.WorkShiftId),
            Start: start,
            UserId: Number(userId),
            WorkSiteId: job.WorksiteId !== null ? Number(job.WorksiteId) : null
        };
    }
    static adaptAbsenceItem(absence, userId) {
        const { start, end } = PostMultipleEventsToPlannerV2Adapter.getCreatedEventPeriod(absence);
        const endIsInclusive = end.endsWith('T23:59:59');
        return {
            Comments: absence.Comments,
            DepartmentId: Number(absence.DepartmentId),
            End: endIsInclusive ? dayjs(end).add(1, 'day').startOf('day').format(WTS_MOMENT_DATE_MASK) : end,
            IsDeleted: absence.Flags === ABSENCES_FLAG.Cancelled,
            IsPlanned: absence.Flags === ABSENCES_FLAG.Planned,
            IsRestricted: absence.IsRestricted,
            JobId: Number(absence.LeaveId),
            Start: start,
            UserId: Number(userId)
        };
    }
    static getCreatedEventPeriod(event) {
        const isLeave = !isNil(event.LeaveId);
        const startDate = (event.StartDate || event.StartDateTime)?.split('T')[0];
        const startTime = (event.StartTime?.length === 5 ? `${event.StartTime}:00` : event.StartTime) || '00:00:00';
        let start = `${startDate}T${startTime}`;
        const endDate = (event.EndDate || event.EndDateTime)?.split('T')[0];
        const endTime = (event.EndTime?.length === 5 ? `${event.EndTime}:00` : event.EndTime) || '00:00:00';
        let end = `${endDate}T${endTime}`;
        if (start >= end || isLeave)
            end = dayjs(end).add(1, 'day').format(WTS_MOMENT_DATE_MASK);
        if (isLeave) {
            start = dayjs(start).startOf('day').format(WTS_MOMENT_DATE_MASK);
            end = dayjs(end).startOf('day').format(WTS_MOMENT_DATE_MASK);
        }
        return { start, end };
    }
}
export default PostMultipleEventsToPlannerV2Adapter;
